export const detectBranchIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete branch" || cleaned === "remove branch") {
        return { intent: "delete_branch" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) branch/);
    if (deleteMatch) {
        return { intent: "delete_branch", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create branch") || cleaned.includes("add branch")) {
        return { intent: "create_branch" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create branch named (.+)/);
    if (createMatch) {
        return { intent: "create_branch", name: createMatch[1].trim() };
    }

    return null;
};
